// Profile.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const Profile = () => {
  const [admin, setAdmin] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ name: "" });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdmin(res.data);
        setFormData({ name: res.data.name });
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/auth/profile`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmin(res.data);
      setEditMode(false);
    } catch (err) {
      console.error("Error updating profile:", err);
    }
  };

  if (!admin) return <div className="text-white">Loading...</div>;

  return (
    <div className="p-6 max-w-xl mx-auto bg-white rounded-xl shadow-md space-y-4">
      <h2 className="text-xl font-bold mb-2 text-white">Profile</h2>
      {editMode ? (
        <>
          <input
            className="border rounded px-3 py-2 w-full mb-2"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
          />
          <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleUpdate}>
            Save
          </button>
          <button className="ml-2 bg-gray-300 px-4 py-2 rounded" onClick={() => setEditMode(false)}>
            Cancel
          </button>
        </>
      ) : (
        <>
          <p><strong>Name:</strong> {admin.name}</p>
          <p><strong>Email:</strong> {admin.email}</p>
          <button
            className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
            onClick={() => setEditMode(true)}
          >
            Edit Profile
          </button>
        </>
      )}
    </div>
  );
};

export default Profile;
